import React from "react";
import { Grid } from "@mui/material";
import { useRecoilState } from "recoil";
import { NewRequisitionTextField } from "./NewRequisition.styles";
import { currentNewRequisitionEdit } from "../../recoil/atoms";
import { validateEmail } from "../../utils/hooks/helpers";

const NewReqBillToPatient: React.FC = () => {
  const [newRequisition, setNewRequisition] = useRecoilState(
    currentNewRequisitionEdit,
  );
  const { requisitionForm } = newRequisition;

  const isDisable = requisitionForm.insuranceSheetAttached
    ? { opacity: 0.35 }
    : { opacity: 1 };

  return (
    <>
      <br />
      <Grid item xs={12} sx={isDisable}>
        <NewRequisitionTextField
          id="new-test-billing-ins-email"
          fullWidth
          focused
          placeholder="Email Address"
          label="Email Address"
          required
          error={
            (requisitionForm.emailAddress.length > 6 &&
              validateEmail(requisitionForm.emailAddress)) ||
            (!newRequisition.isError && !requisitionForm.emailAddress.length)
              ? ""
              : "Please enter a valid email address."
          }
          $showHelpertext={Boolean(
            requisitionForm.emailAddress &&
            !validateEmail(requisitionForm.emailAddress),
          )}
          variant="standard"
          disabled={
            requisitionForm.insuranceSheetAttached ||
            !requisitionForm.billToPatient
          }
          value={requisitionForm.emailAddress}
          onChange={(e) =>
            setNewRequisition({
              ...newRequisition,
              requisitionForm: {
                ...newRequisition.requisitionForm,
                emailAddress: e.target.value,
              },
            })
          }
        />
      </Grid>
    </>
  );
};
export default NewReqBillToPatient;
